import { render, staticRenderFns } from "./CompositionApiTryItNow.vue?vue&type=template&id=4a5af15f&scoped=true&functional=true&"
var script = {}
import style0 from "./CompositionApiTryItNow.vue?vue&type=style&index=0&id=4a5af15f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4a5af15f",
  null
  
)

export default component.exports